<div class="flex flex-col">
  <div class="flex flex-row justify-between flex-nowrap center-v pt-2 pb-2 border-box">
    <h4 class="text-lg font-bold pl-2">
      {{ '#TIME_REPORT.DIALOGS.PARTY.TITLE' | translate }}
    </h4>
    <span
      class="text-sm color-light selection-count pr-4"
      [ngStyle]="{
        visibility: (selectedPersons?.length ?? 0) > 0 ? 'visible' : 'hidden',
      }"
      >
      ({{ selectedPersons?.length }}
      {{ '#TIME_REPORT.DIALOGS.PARTY.SELECTED_COUNT_POSTFIX' | translate }})
    </span>
  </div>

  <div class="flex flex-row mr-2 mt-2 border-box">
    <soft-input
      placeholder="Suche nach Person"
      class="border-box mr-2 ml-2"
      #search
      (valueChange)="searchInput$.next(search?.value() ?? '')"
    ></soft-input>
  </div>

  @if (loading$ | async) {
    <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
  }

  @if (filteredPersons$ | async; as partyPersons) {
    @if ((partyPersons?.length ?? 0) > 0) {
      <div
        class="flex flex-col"
        style="position: relative; flex-grow: 1; flex-shrink: 0"
        >
        <ul
          class="button-spacing soft-list mt-2 border-box soft-scroll soft-scrollno-horizontal soft-scroll-vertical pt-2 pr-2 pl-2 pb-1 border-box"
          style="max-height: 60vh"
          >
          @for (person of partyPersons; track person; let i = $index) {
            <li
              class="soft-list-item custom-item"
              [class.selected-employee]="person | isSelected: selectedPersons : comparerFn"
              >
              <div class="flex flex-row justify-center flex-nowrap space-between">
                <div class="flex flex-col flex-nowrap" (click)="selectOrUnselect(person)">
                  <strong>{{ person?.vorname }} {{ person?.zuname }}</strong>
                  <p class="text-sm color-light mb-0 mt-0">
                    {{ person?.persnr }}
                  </p>
                </div>
                <span
                  class="icon"
                  style="display: inline-block"
                  (click)="favoriteChange(person)"
                  >
                  <i
                    class="fa-star"
                    [ngClass]="person?.favorite ? 'fa-solid' : 'fa-regular'"
                  ></i>
                </span>
              </div>
            </li>
          }
        </ul>
        <div class="flex flex-row items-center" style="bottom: 0">
          <button
            class="soft-button accent w-full text-center large-button rounded-md m-4"
            (click)="close(selectedPersons)"
            >
            <soft-icon name="fa-regular fa-save" class="m-4 ml-0"></soft-icon>
            {{ '#TIME_REPORT.DIALOGS.PARTY.SAVE' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div style="width: calc(100% - 1rem)">
        <div class="text-sm color-light mt-4 pt-2 mb-2 pb-2 text-center flex flex-row justify-center">
          {{ '#TIME_REPORT.DIALOGS.PARTY.NO_PERSONS_FOUND' | translate }}
        </div>
      </div>
    }
  } @else {
    <div class="flex flex-row justify-center spinner-container">
      <soft-loading-spinner class="spin"></soft-loading-spinner>
    </div>
  }

  <ng-template #loadingTemplate>
    <div class="flex flex-row justify-center spinner-container">
      <soft-loading-spinner class="spin"></soft-loading-spinner>
    </div>
  </ng-template>
</div>
